
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship  </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm chess-competition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2> Maharastra State Under 12 Open & Girls <span> Selection
                        Chess Championship</span></h2>
            </div>
            <div class="widget_title inner-title">
                <h4>CHESS CHAMPIONSHIP 2022</h4>
            </div>
            <div class>
                <iframe style="width: 100%; height: 700px;"
                    src="https://drive.google.com/file/d/1BnBYs5jBa0S5p_mvD1lcoGsmjGTpkEAS/preview"></iframe>
            </div>
        </div>
    </div>
</section>
